import { Routes } from '@angular/router';

import { azureManagementRoutes } from '@advania-cosoftware/wolf-azure-management';
import { itFinancialV2Routes } from '@advania-cosoftware/wolf-it-financial-v2';
import { applicationsRoutes } from '@advania-cosoftware/wolf-it-resources';
import {
    accountsRoutes,
    advaniaServicesChildRoutes,
    azureTenantsRoutes,
    devicesRoutes,
    documentsRoutes,
    homeRoutes,
    itClimateRoutes,
    itFinancialRoutes,
    locationsRoutes,
    microsoftLicensesRoutes,
    microsoftServicesRoutes,
    networkRoutes,
} from '@advania-cosoftware/wolf-legacy';
import { mobileDeviceManagementRoutes } from '@advania-cosoftware/wolf-mobile-device-management';
import { projectsRoutes } from '@advania-cosoftware/wolf-projects';
import { advaniaServicesRoutes } from '@advania-cosoftware/wolf-services';

export const customerRoutes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'home' },
    ...homeRoutes,
    ...accountsRoutes,
    ...advaniaServicesRoutes([
        ...advaniaServicesChildRoutes,
        ...azureManagementRoutes,
        ...mobileDeviceManagementRoutes,
    ]),
    ...microsoftServicesRoutes,
    ...itFinancialRoutes,
    ...itFinancialV2Routes,
    ...itClimateRoutes,
    ...documentsRoutes,
    ...projectsRoutes,
    ...applicationsRoutes,
    ...devicesRoutes,
    ...networkRoutes,
    ...microsoftLicensesRoutes,
    ...azureTenantsRoutes,
    ...locationsRoutes,
    { path: '**', redirectTo: 'home' },
];
